import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './app.css'
import AppContextProvider from '@store/context'

import App from './App.tsx'
import { ErrorBoundary } from "react-error-boundary";
import {ErrorFallback} from "@ui/components/error-boundary/error-boundary.component";


createRoot(document.getElementById('root')!).render(
  //  <StrictMode>
    	<AppContextProvider>
     <ErrorBoundary FallbackComponent={ErrorFallback}>
    <App />
   
    </ErrorBoundary>
    </AppContextProvider>
  // </StrictMode>,
)
